export const FORM_BORDER = 'border border-slate-200' as const;
export const FORM_BORDER_HOVER = 'hover:border-slate-300' as const;
export const FORM_BORDER_ERROR = 'border border-red-400' as const;

export const FOCUS_RING =
  'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1' as const;
export const FOCUS_RING_ERROR =
  'focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-1' as const;

export const FORM_RADIUS = 'rounded-xl' as const;
export const FORM_RADIUS_FULL = 'rounded-full' as const;

export const FORM_SHADOW = 'shadow-lg shadow-slate-200/60' as const;

export const LABEL_TEXT = 'text-sm font-medium text-slate-600' as const;
export const ERROR_TEXT = 'mt-1 text-sm text-red-600' as const;

export const DROPDOWN_ANIMATION = 'ease-ui data-[state=open]:duration-150 data-[state=closed]:duration-100 data-[state=open]:animate-in data-[state=open]:fade-in-0 motion-safe:data-[state=open]:zoom-in-95 data-[state=closed]:opacity-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 motion-safe:data-[state=closed]:zoom-out-95 data-[state=closed]:fill-mode-forwards' as const;
export const MODAL_ANIMATION = 'ease-ui data-[state=open]:duration-200 data-[state=closed]:duration-150 data-[state=open]:animate-in data-[state=open]:fade-in-0 motion-safe:data-[state=open]:zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 motion-safe:data-[state=closed]:zoom-out-95 data-[state=closed]:fill-mode-forwards' as const;
export const DROPDOWN_BG = 'bg-white border border-slate-100' as const;
export const ITEM_HOVER = 'hover:bg-slate-50' as const;
